<template>
  <div class="flex flex-col items-center gap-3 text-xl text-dlubal-blue font-bold text-center">
    <a
      target="_blank"
      :href="miaLink"
      class="relative rounded-full"
    >
      <img
        src="@/assets/images/avatar-big.png"
        alt="Mia Avatar"
        class="w-[114px] h-[114px]"
      />
      <span class="flex items-center gap-0.5 absolute bottom-0 left-0 translate-x-[15px] translate-y-[-10%]">
        <span class="bg-green block rounded-full w-4 h-4">&nbsp;</span>
      </span>
    </a>
    <a
      data-test="welcome_message_place_holder"
      target="_blank"
      :href="miaLink"
      v-html="$t('placeholder.welcomeMessage')"
    ></a>
  </div>
</template>

<script setup lang="ts">
const miaLink = 'https://www.dlubal.com/en/support-and-learning/ai-support/mia-your-ai-expert-for-structural-analysis'
</script>
